<span *ngIf="nameConfig?.scheduleType === 'ad-hoc'">
  <fa-icon [icon]="['fal', 'arrow-right-to-arc']"></fa-icon>
  {{ AdHocHumanReadable }}
</span>

<y42-orchestration-name *ngIf="nameConfig?.scheduleType === 'scheduled'" [path]="nameConfig?.scheduledPath">
</y42-orchestration-name>
